module.exports = __webpack_public_path__ + "portal-r3-logo.4174ec03d7773515aa447fbd949ae789.svg";